module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    attrs: {
      "options": {
        group: 'widgets',
        draggable: _vm.draggable,
        handle: '.arrow-move'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      }
    },
    model: {
      value: (_vm.widgets),
      callback: function($$v) {
        _vm.widgets = $$v
      },
      expression: "widgets"
    }
  }, _vm._l((_vm.widgets), function(widget) {
    return _c(widget.name, {
      key: widget.id,
      tag: "component",
      attrs: {
        "mode": widget.type
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445162f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Widget.vue
// module id = 1625
// module chunks = 1